import { YES } from '../constants';
import urls from './urls';
import { axiosPost, axiosPut, getSourceId } from './common';
import { addAnalyticEvent } from '../analytics/common';
import { telemarketingOptOut } from '../analytics/telemarketing';

function unsubscribeTelemarketing(phoneNumber, callback, err) {
  const request = {
    sourceId: getSourceId(),
    globalOptOut: YES,
    phoneNumber
  };

  const successCallback = (res) => {
    try {
      callback(res);
    } finally {
      addAnalyticEvent(telemarketingOptOut);
    }
  };

  axiosPut({
    url: urls.UPDATE_TELEMARKETING,
    data: request,
    callback: successCallback,
    err
  });
}

function retrieveTelemarketingPreferences(phoneNumber, callback, err) {
  const request = {
    sourceId: getSourceId(),
    phoneNumber

  };

  const handleRetrieveError = (error) => {
    err(error);
  };
  axiosPost({
    url: urls.RETRIEVE_TELEMARKETING,
    data: request,
    callback,
    err: handleRetrieveError
  });
}

export {
  unsubscribeTelemarketing,
  retrieveTelemarketingPreferences,
};
